// @ts-nocheck
import * as React from "react";

const CogwheelOutline: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
            <path
                d="M43.8 73.9 41.2 75l-1.8-2.3c-.1-.2-.3-.2-.5-.2-.8.1-1.7.1-2.4 0-.2 0-.4.1-.5.2L34.1 75l-2.6-1.1.3-3c0-.2-.1-.4-.2-.5-.6-.5-1.3-1.1-1.7-1.7-.1-.2-.3-.2-.5-.2l-3 .3-1.1-2.7 2.3-1.8c.2-.1.2-.3.2-.5-.1-.8-.1-1.7 0-2.4 0-.2-.1-.4-.2-.5L25.3 59l1.1-2.7 3 .3c.2 0 .4-.1.5-.2.5-.6 1.1-1.3 1.7-1.7.2-.1.3-.3.2-.5l-.3-3 2.6-1.1 1.8 2.3c.1.2.3.2.5.2.8-.1 1.7-.1 2.4 0 .2 0 .4 0 .5-.2l1.8-2.3 2.7 1.1-.3 2.9c0 .2.1.4.2.5.6.5 1.3 1.1 1.7 1.8.1.2.3.2.5.2l3-.3L50 59l-2.3 1.8c-.2.1-.2.3-.2.5.1.8.1 1.7 0 2.4 0 .2.1.4.2.5L50 66l-1.1 2.7-3-.3c-.2 0-.4.1-.5.2-.5.6-1.1 1.3-1.7 1.8-.2.1-.3.3-.2.5z"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
            <circle
                cx="37.6"
                cy="62.5"
                r="3.7"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
            <path
                d="M61 56.2h-3.6l-1-3.4c-.1-.2-.2-.3-.4-.4-1-.2-1.9-.6-2.8-1.2q-.3-.15-.6 0l-3.2 1.7-2.5-2.5 1.8-3.2q.15-.3 0-.6c-.5-.8-.8-1.8-1.2-2.8-.1-.2-.2-.3-.4-.4l-3.5-1v-3.6l3.5-1c.2-.1.3-.2.4-.4.2-1 .6-1.9 1.2-2.8q.15-.3 0-.6L47 30.8l2.4-2.4 3.2 1.7q.3.15.6 0c.8-.5 1.8-.8 2.8-1.2.2-.1.3-.2.4-.4l1-3.5h3.5l1 3.5c.1.2.2.3.4.4 1 .2 1.9.6 2.8 1.2q.3.15.6 0l3.2-1.7 2.4 2.4-1.7 3.2q-.15.3 0 .6c.5.8.8 1.8 1.2 2.8.1.2.2.3.4.4l3.5 1v3.6l-3.5 1c-.2.1-.3.2-.4.4-.2 1-.6 1.9-1.2 2.8q-.15.3 0 .6l1.8 3.2-2.6 2.5-3.2-1.7q-.3-.15-.6 0c-.8.5-1.8.8-2.8 1.2-.2.1-.3.2-.4.4z"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
            <circle cx="59.2" cy="40.8" r="5" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="2" />
        </svg>
    );
};

export default React.memo(CogwheelOutline);
